module.exports = __webpack_public_path__ + "static/image_2-1deb3c59c14e66462ee7dcf571fa5e00.jpg";